<script>
  import { afterUpdate, onDestroy } from 'svelte';

  import { activeSectionId } from './scrollspy.store';

  let sections = [];
  let container;
  let elementsInView = [];
  let observer;
  let threshold = [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1];
  let rootMargin = '0px';

  const setup = () => {
    const sectionElements = Array.from(container.querySelectorAll('[data-spy]'));

    sections = sectionElements.map(({ id }) => id);

    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const id = entry.target.id;

          if (entry.isIntersecting && entry.intersectionRatio > 0.3) {
            if (sections.indexOf(id) < sections.indexOf(elementsInView[0])) {
              if (!elementsInView.includes(id)) {
                elementsInView.unshift(id);
              }
            } else {
              if (!elementsInView.includes(id)) {
                elementsInView.push(id);
              }
            }
          } else {
            const elementsInViewPosition = elementsInView.indexOf(id);
            elementsInViewPosition > -1 && elementsInView.splice(elementsInViewPosition, 1);
          }
        });

        activeSectionId.set(elementsInView[0]);
      },
      { threshold, root: container.firstChild, rootMargin }
    );

    sectionElements.forEach((el) => observer.observe(el));
  };

  afterUpdate(() => setTimeout(setup, 100));

  onDestroy(() => observer?.disconnect());
</script>

<div bind:this={container}>
  <slot />
</div>
